import { bind } from "@react-rxjs/core"
import { BehaviorSubject, map } from "rxjs"

import { ThemeName, themes } from "./themes"

/**
 * @README
 * The Behavior Subject must be initialized with a value from localStorage
 * before defaulting to Dark mode; otherwise the Subject will always start
 * with Dark mode even if the user has previously selected Light mode.
 */
const themeName = localStorage.getItem("themeName") as ThemeName
const themeName$ = new BehaviorSubject(themeName || ThemeName.Dark)

export const setThemeNameObs = (name: ThemeName) => themeName$.next(name)
export const theme$ = themeName$.pipe(map((name) => themes[name]))

export const [useCurrentTheme] = bind(theme$)
